import React from "react";

const educationContent = [
  {
    year: "2019-2021",
    degree: "MBA Finance",
    institute: "S. B. Collage of Art & Commerce - Aurangabad",
    details: `Specializing in financial management and strategic decision-making.`,
  },
  {
    year: "2015-2017",
    degree: "Master of Arts: Mass Communications & Journalism",
    institute: "MGM Collage of Mass Communication & Journalism - Aurangabad",
    details: `Focusing on media studies, journalism, and communication strategies.`,
  },
  {
    year: "2012-2015",
    degree: "Bachelor of Arts: Mass Communications And Journalism ",
    institute: "MGM Collage of Mass Communication & Journalism - Aurangabad",
    details: `Specializing in media theory, journalism, and communication practices.`,
  },
];

const experienceContent = [
  {
    year: "2022 - Present",
    position: "Associate Line Producer",
    compnayName: "Red Chillies Vfx, Mumbai, Maharashtra",
    details: `Coordinating production schedules, managing resources, and ensuring smooth workflow across various VFX projects.`,
  },
  {
    year: "2020 - 2022",
    position: "Line Producer",
    compnayName: "Redefine VFX, Mumbai, Maharashtra",
    details: `Overseeing production timelines, managing budgets, and coordinating team efforts for successful project delivery`,
  },
  {
    year: "2019 - 2020",
    position: "Operations Manager",
    compnayName: "Coherent Mediawork PVT LTD, Mumbai, Maharashtra",
    details: `Overseeing daily operations, streamlining processes, and ensuring efficient workflow across departments.`,
  },
  {
    year: "2017 - 2019",
    position: "Studio Manager",
    compnayName: "IcastX Technology , Mumbai, Maharashtra",
    details: `I oversee operations, streamline processes, and ensure efficient departmental workflow.`,
  },
  {
    year: "2016 - 2017",
    position: "Video Producer",
    compnayName: "DGIPR Government Of Maharashtra, Mumbai, Maharashtra",
    details: `Responsible for managing video production, coordinating teams, and ensuring high-quality content delivery for government projects.`,
  },
  {
    year: "2015 - 2016",
    position: "Public Relations Officer",
    compnayName: "DGIPR Government Of Maharashtra, Mumbai, Maharashtra",
    details: `Responsible for managing communication strategies, enhancing media relations, and ensuring effective dissemination of government information.`,
  },
  {
    year: "2014 - 2015",
    position: "Freelance PRO",
    compnayName: "Marathi Film Industry , Aurangabad, Maharashtra",
    details: `I freelanced for Marathi films, handling PR campaigns, media management, and organizing promotional events.`,
  },
  {
    year: "2012 - 2014",
    position: "Sub Editor",
    compnayName: "Marathi Film Industry , Aurangabad, Maharashtra",
    details: `I started as an intern for six months, later becoming a Sub Editor, creating content for social and digital media while developing camera and content-making skills.`,
  },
];

const Exp = () => {
  return (
    <div>



       {/* Experience Section */}
       <h3 className="section-title">Experience</h3>
      <ul>
        {experienceContent.map((val, i) => (
          <li key={i}>
            <div className="icon">
              <i className="fa fa-briefcase"></i>
            </div>
            <span className="time open-sans-font text-uppercase">{val.year}</span>
            <h5 className="poppins-font text-uppercase">
              {val.position}
              <span className="place open-sans-font">{val.compnayName}</span>
            </h5>
            <p className="open-sans-font">{val.details}</p>
          </li>
        ))}
      </ul>
      
      {/* Education Section */}
      <h3 className="section-title">Education</h3>
      <ul>
        {educationContent.map((val, i) => (
          <li key={i}>
            <div className="icon">
              <i className="fa fa-graduation-cap"></i>
            </div>
            <span className="time open-sans-font text-uppercase">{val.year}</span>
            <h5 className="poppins-font text-uppercase">
              {val.degree}
              <span className="place open-sans-font">{val.institute}</span>
            </h5>
            <p className="open-sans-font">{val.details}</p>
          </li>
        ))}
      </ul>

     
    </div>
  );
};

export default Exp;
